import React, { useState } from "react";
import { HashRouter, useLocation } from "react-router-dom";
import Header from "./Components/Header";
import Sidebar from "./Components/Sidebar";

import Content from "./Components/Content";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AppContent() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen((open) => !open);
  const [imageChange, setImageChange] = useState(false);
  const imagetoggle = () => setImageChange((open) => !open);
  const location = useLocation();

  const setToggleFalse = () => {
    setIsOpen(false);
  };

  // Routes that should not show header and sidebar
  const standaloneRoutes = ['/terms-viewer'];
  const isStandalonePage = standaloneRoutes.some(route =>
    location.pathname.includes(route)
  );

  return (
    <>
      {!isStandalonePage && (
        <>
          <Header
            isOpen={isOpen}
            toggle={toggle}
            imageChange={imageChange}
            imagetoggle={imagetoggle}
          />
          <Sidebar
            isOpen={isOpen}
            toggle={toggle}
            imageChange={imageChange}
            imagetoggle={imagetoggle}
            setToggleFalse={setToggleFalse}
          />
        </>
      )}
      <Content
        isOpen={isOpen}
        toggle={toggle}
        imagetoggle={imagetoggle}
        setToggleFalse={setToggleFalse}
      />
      <ToastContainer limit={1} autoClose={8000} />
      <div
        id="hotspot-container"
        name="hotspot-container"
        className="hotspot-container hidden"
      >
        <div id="hotspot" name="hotspot" className="hotspot hidden" />
        <div
          id="hotspot-bubble"
          name="hotspot-bubble"
          className="hotspot-bubble hidden"
        >
          Demo Hot-Spot Bubble
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <HashRouter>
      <AppContent />
    </HashRouter>
  );
}

export default App;
